import { render } from "./MarketDetailsScreen.vue?vue&type=template&id=18d09df6&scoped=true"
import script from "./MarketDetailsScreen.vue?vue&type=script&lang=js"
export * from "./MarketDetailsScreen.vue?vue&type=script&lang=js"

import "./MarketDetailsScreen.vue?vue&type=style&index=0&id=18d09df6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d09df6"]])

export default __exports__